import { render, staticRenderFns } from "./create-group.vue?vue&type=template&id=f9465a02&scoped=true"
import script from "./create-group.vue?vue&type=script&lang=js"
export * from "./create-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9465a02",
  null
  
)

export default component.exports